import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

import Button from '../Button';

import * as bookmarks from '../../utils/bookmarks';

import styles from './BookmarkButton.module.scss';

const BookmarkButton = ({
    id,
    url,
    isNextToShare,
    untranslatedModifiers = [],
    untranslatedButtonModifiers,
}) => {
    const { t } = useTranslation('common');
    const [bookmarked, setBookmarked] = useState(false);

    const handleBookmarkToggle = () => {
        if (bookmarked) {
            bookmarks.removeBookmark(id);
            setBookmarked(false);
        } else {
            bookmarks.addBookmark({
                id,
                url,
            });
            setBookmarked(true);
        }
    };

    useEffect(() => {
        setBookmarked(bookmarks.isBookmarked(id));
    }, [id]);

    const icon = bookmarked ? 'Bookmarked' : 'Bookmark';

    const text = bookmarked
        ? t('bookmarkbutton.saved')
        : t('bookmarkbutton.save');

    const classes = classNames(
        styles['BookmarkButton'],
        untranslatedModifiers.map((x) => styles[x])
    );

    return (
        <div className={classes}>
            <div className={styles['BookmarkButton__Container']}>
                <Button
                    onClick={handleBookmarkToggle}
                    text={text}
                    type={isNextToShare ? 'SecondarySmall' : 'PrimarySmall'}
                    minWidth="150px"
                    icon={icon}
                    untranslatedModifiers={untranslatedButtonModifiers}
                />
            </div>
        </div>
    );
};

BookmarkButton.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    url: PropTypes.string,
    isNextToShare: PropTypes.bool,
    untranslatedModifiers: PropTypes.arrayOf(PropTypes.string),
    untranslatedButtonModifiers: PropTypes.arrayOf(PropTypes.string),
};

BookmarkButton.defaultProps = {
    id: '',
    url: '',
    isNextToShare: false,
    untranslatedModifiers: [],
    untranslatedButtonModifiers: [],
};

export default BookmarkButton;
